import { action, makeObservable, observable } from "mobx";
import { Sonho } from "../types";
import { generateUUID } from "../utils";

export class SonhoStoreClass {
  data: Sonho[] | null = null;
  selectedData: Sonho | null = null;
  loading: boolean = false;
  crudLoading = {
    edit: false,
    delete: false,
    get: false,
    add: false,
  };

  constructor() {
    makeObservable(this, {
      data: observable,
      selectedData: observable,
      loading: observable,
      setLoading: action,
      crudLoading: observable,
      setCrudLoading: action,
      set: action,
    });
  }

  // Action to set loading state
  setLoading(loading: boolean) {
    this.loading = loading;
  }

  // Action to set CRUD loading state
  setCrudLoading(type: keyof typeof this.crudLoading, loading: boolean) {
    this.crudLoading[type] = loading;
  }

  set(value: Sonho[]) {
    this.data = value;
  }

  setSelectedData(value: Sonho) {
    this.selectedData = value;
  }

  add(item: Sonho) {
    console.log(`produto.store, method ADD`);
    if (!this.data) {
      this.data = [];
    }

    this.data.push({ ...item, id: item["id"] ?? generateUUID() });
  }

  removeItem(predicate: (item: Sonho) => boolean) {
    console.log(`produto.store, method Remove`);

    if (!this.data) {
      return;
    }

    this.data = this.data.filter((item) => !predicate(item));
  }

  update(id: string, updates: Partial<Sonho>): void {
    if (!this.data) {
      return;
    }

    const itemIndex = this.data.findIndex((item) => item["id"] === id);
    if (itemIndex !== -1) {
      this.data[itemIndex] = { ...this.data[itemIndex], ...updates };
    }
  }
}

const SonhoStore = new SonhoStoreClass();

export default SonhoStore;
